import React from "react";
import { useState, useEffect } from 'react';
import { Alert, Button, ListGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { grantVacations, grantBulk } from "../../services/VacationHistoryService";
import { getAllEmployees } from "../../services/EmployeesService";

function GrantDays() {

    const currentYear = new Date().getFullYear();
    const bulkYearOptions = [String(currentYear), String(currentYear + 1)];

    const [userEmail, setUserEmail] = useState("");
    const [days, setDays] = useState("");
    const [year, setYear] = useState("");
    const [comment, setComment] = useState("");
    const [isValidDays, setIsValidDays] = useState(true);
    const [isValidYear, setIsValidYear] = useState(true);
    const [suggestions, setSuggetions] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [isValidEmail, setIsValidEmail] = useState(true);


    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => {
        setShowSuccess(false);
        window.location.reload();
    }
    const handleShowSuccess = () => {
        setShowError(false);
        setShowSuccess(true);
    };

    const [showError, setShowError] = useState(false);
    const handleCloseError = () => setShowError(false);
    const handleShowError = () => {
        setShowSuccess(false);
        setShowError(true);
    }

    const [showBulkConfirm, setShowBulkConfirm] = useState(false);
    const [bulkLoading, setBulkLoading] = useState(false);
    const [bulkResult, setBulkResult] = useState(null);
    const [bulkError, setBulkError] = useState(false);
    const [bulkYear, setBulkYear] = useState(() => String(new Date().getFullYear()));
    const isValidBulkYear = bulkYearOptions.includes(bulkYear);

    const handleChangeBulkYear = (e) => {
        setBulkYear(e.target.value);
    };

    const handleBulkButtonClick = () => {
        if (!isValidBulkYear) {
            return;
        }
        setBulkResult(null);
        setBulkError(false);
        setShowBulkConfirm(true);
    };

    const handleBulkCancel = () => {
        setShowBulkConfirm(false);
    };

    const handleBulkConfirm = async () => {
        if (!isValidBulkYear) {
            return;
        }
        setShowBulkConfirm(false);
        setBulkLoading(true);
        setBulkResult(null);
        setBulkError(false);
        try {
            const response = await grantBulk(bulkYear);
            if (response === undefined || response.status !== 200) {
                setBulkError(true);
            } else {
                setBulkResult(response.data);
            }
        } catch (error) {
            setBulkError(true);
        } finally {
            setBulkLoading(false);
        }
    };

    const handleChangeUser = (e) => {
        setUserEmail(e.target.value);
        setIsValidEmail(e.target.value.endsWith('@qualt.io'));
        const newSuggestions = usersList.filter((valor) =>
            valor.toLowerCase().startsWith(e.target.value.toLowerCase())
        );
        setSuggetions(newSuggestions);
    }

    const handleChangeDays = (e) => {
        setDays(e.target.value);
        setIsValidDays(e.target.value < 40);
    };

    const handleChangeYear = (e) => {
        setYear(e.target.value);
        setIsValidYear(e.target.value === new Date().getFullYear().toString() || e.target.value === (new Date().getFullYear()+1).toString());
    };

    const handleChangeComment = (e) => {
        setComment(e.target.value);
    };

    const selectSuggestion = (suggestions) => {
        setUserEmail(suggestions);
        setIsValidEmail(true);
        setSuggetions([]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let formData = {
            user_email: userEmail,
            total_days: days,
            year: year,
            comment: comment
        }
        if (isValidDays && isValidYear) {
            grantVacations(JSON.stringify(formData)).then(function(response) {
                if(response === undefined){
                    handleShowError();
                } else {
                    if(response.status === 200) {
                        handleShowSuccess();
                    } else {
                        handleShowError();
                    }
                } 
            });
        }
    }

    const getUserList = async () => {
        let res = await getAllEmployees();
        let emails = [];
        for (const key in res) {
            emails.push(res[key].email);
        }
        return emails;
    }

    useEffect(() => {
        getUserList().then((data) => {
            setUsersList(data);
        })
    }, [])

    return (
        <div className="container home">
            <Alert variant="success" show={showSuccess} onClose={handleCloseSuccess} dismissible>
                <p>
                Días de vacaciones asignadas correctamente.
                </p>
            </Alert>
            <Alert variant="danger" show={showError} onClose={handleCloseError} dismissible>
                <p>
                Se ha producido un error.
                </p>
            </Alert>
            <h1 className="font-weight-light">Asignar días de vacaciones</h1>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicId">
                <Form.Label>Email del empleado</Form.Label>
                <Form.Control 
                    required
                    placeholder="Email" 
                    value={userEmail}
                    onChange={handleChangeUser}
                    isInvalid={!isValidEmail}
                />
                <ListGroup as="ul">
                    {suggestions.map((suggestion, index) => (
                        <ListGroup.Item action as="li" key={index} onClick={() => selectSuggestion(suggestion)}>
                        {suggestion}
                        </ListGroup.Item>
                    ))}
                </ListGroup>
                <Form.Control.Feedback type="invalid">
                    Por favor indica un email de usuario válido.
                </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicDays">
                <Form.Label>Número de días</Form.Label>
                <Form.Control 
                    required
                    placeholder="Días" 
                    value={days}
                    onChange={handleChangeDays}
                    isInvalid={!isValidDays}
                />
                <Form.Control.Feedback type="invalid">
                    El número máximo de días es de 40.
                </Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group className="mb-3" controlId="formBasicYear">
                <Form.Label>Año</Form.Label>
                <Form.Control 
                    required
                    placeholder="Año"
                    value={year}
                    onChange={handleChangeYear}
                    isInvalid={!isValidYear}
                />
                <Form.Control.Feedback type="invalid">
                    Por favor indica un año válido.
                </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicComment">
                <Form.Label>Comentario</Form.Label>
                <Form.Control 
                    placeholder="Comentario"
                    value={comment}
                    onChange={handleChangeComment}
                />
                </Form.Group>

                <Button variant="primary" type="submit">
                Enviar
                </Button>
            </Form>

            <hr />

            <h2 className="font-weight-light">Asignación masiva de días estándar</h2>
            <Form.Group className="mb-3" controlId="bulkGrantYear">
                <Form.Label>Año de asignación</Form.Label>
                <Form.Select
                    value={bulkYear}
                    onChange={handleChangeBulkYear}
                    disabled={bulkLoading || showBulkConfirm}
                >
                    {bulkYearOptions.map((option) => (
                        <option key={option} value={option}>{option}</option>
                    ))}
                </Form.Select>
            </Form.Group>
            {!showBulkConfirm && (
                <Button variant="warning" onClick={handleBulkButtonClick} disabled={bulkLoading || !isValidBulkYear}>
                    Asignar días estándar
                </Button>
            )}
            {showBulkConfirm && (
                <div>
                    <p>¿Confirmas la asignación de 22 días para el año {bulkYear}?</p>
                    <p>Se registrará el comentario "Vacaciones correspondientes {bulkYear}".</p>
                    <Button variant="danger" onClick={handleBulkConfirm} disabled={!isValidBulkYear}>
                        Confirmar
                    </Button>
                    {' '}
                    <Button variant="secondary" onClick={handleBulkCancel}>
                        Cancelar
                    </Button>
                </div>
            )}
            {bulkLoading && <p>Procesando asignación masiva...</p>}
            {bulkResult && (
                <p>Asignados: {bulkResult.assigned_count}. Omitidos: {bulkResult.skipped_count}.</p>
            )}
            {bulkError && (
                <p>No se pudo completar la asignación masiva.</p>
            )}
        </div>
    );
}

export default GrantDays;